module.exports = __webpack_public_path__ + "static/media/output-onlinepngtools.b9bd094b.png";